/**
 * Product brand — single source of truth.
 *
 * Final name (2026-10-04): "The Figure Co." The earlier codenames "ClaimSync"
 * (trademarked by a third party) and "ClaimGenius" (interim placeholder) are
 * retired — see RETIRED_BRAND_NAMES.
 *
 * RULE: every surface that prints the product name (wordmark, ⌘K, breadcrumbs,
 * document title, legal pages, email signatures) MUST read it from here.
 *
 * Usage:
 *   import { BRAND_NAME, BRAND_TAGLINE } from '@/config/brand';
 *   <span>{BRAND_NAME}</span>
 */

/** User-facing product name. */
export const BRAND_NAME = 'The Figure Co.';

/** Short descriptor under the wordmark / in the rail. */
export const BRAND_TAGLINE = 'Forensic BI';

/** Legal entity name used in Terms / Privacy / Contact / copyright. */
export const BRAND_LEGAL_ENTITY = `${BRAND_NAME}, Inc.`;

/** Domain descriptor used in the browser title + meta description. */
export const BRAND_DESCRIPTOR = 'Business Interruption';

/**
 * Names this product must NOT ship — trademarked or retired codenames. A unit
 * test asserts `BRAND_NAME` is none of these so the trademarked name can't creep
 * back in (and so a stale find-and-replace gets caught).
 */
export const RETIRED_BRAND_NAMES = ['ClaimSync', 'ClaimGenius'] as const;

/** Composed document title, e.g. "ClaimGenius – Business Interruption". */
export const BRAND_TITLE = `${BRAND_NAME} – ${BRAND_DESCRIPTOR}`;

/** Composed meta description. */
export const BRAND_META_DESCRIPTION = `${BRAND_NAME} — Business Interruption Claims Calculator`;

/** Copyright line, e.g. "© 2026 ClaimGenius, Inc.". */
export function brandCopyright(year: number = new Date().getFullYear()): string {
  return `© ${year} ${BRAND_LEGAL_ENTITY}`;
}
